import { jsPDF } from 'jspdf';
import { baskervvilleRegularBase64 } from '../assets/fonts/Baskervville-Regular-normal.js';

/**
 * Setup fonts for PDF generation with proper embedding
 * @param {Object} doc - jsPDF instance
 * @returns {Boolean} - Success status
 */
export function setupPDFFonts(doc) {
  console.log('Setting up fonts with proper embedding...');

  try {
    // First register Baskervville font
    console.log('Adding Baskervville font to VFS...');
    doc.addFileToVFS(
      'Baskervville-Regular-normal.ttf',
      baskervvilleRegularBase64
    );
    
    // Register the font with identity-h encoding to ensure proper embedding
    console.log('Registering Baskervville font with Unicode support...');
    doc.addFont(
      'Baskervville-Regular-normal.ttf',
      'Baskervville-Regular',
      'normal',
      'Identity-H'
    );
    
    // Set as default font
    doc.setFont('Baskervville-Regular', 'normal');
    doc.setFontSize(12);
    
    // Log font registration success
    const fonts = doc.getFontList();
    console.log('Available fonts after setup:', fonts);
    console.log('Is Baskervville available?', 'Baskervville-Regular' in fonts);
    
    return true;
  } catch (error) {
    console.error('Error in setupPDFFonts:', error);
    return false;
  }
}

/**
 * Get PDF font style from element style
 * @param {Object} style - Element style
 * @returns {Object} - PDF font style
 */
export function getPDFFontStyle(style) {
  // Map font family names to PDF font names
  const fontMap = {
    'Bangers': 'Bangers-Regular',
    'Great Vibes': 'GreatVibes-Regular',
    'Quicksand': 'Quicksand-Regular',
    'Andika': 'Andika-Regular',
    'Baskervville': 'Baskervville-Regular',
    'Arial': 'Helvetica',
    'Times New Roman': 'Times',
  };
  
  const fontFamily = style?.fontFamily || 'Baskervville';
  const pdfFontName = fontMap[fontFamily] || 'Baskervville-Regular';
  
  return {
    fontFamily: pdfFontName,
    fontStyle: style?.fontStyle || 'normal',
    fontWeight: style?.fontWeight || 'normal',
  };
}

/**
 * Simple verification of font embedding in document
 * @param {Object} doc - jsPDF instance
 * @returns {Boolean} - Success status
 */
export function verifyFontEmbedding(doc) {
  try {
    const fonts = doc.getFontList();
    console.log('Fonts in document:', fonts);
    
    // Check for Baskervville
    if (!('Baskervville-Regular' in fonts)) {
      console.error('Baskervville-Regular font not in document');
      return false;
    }
    
    // Get current font details
    const currentFont = doc.getFont();
    console.log('Current font details:', {
      fontName: currentFont.fontName,
      fontStyle: currentFont.fontStyle,
      encoding: currentFont.encoding
    });
    
    return true;
  } catch (error) {
    console.error('Error in verifyFontEmbedding:', error);
    return false;
  }
}
